import { lengthContraction } from '@/domain/physics/SpecialRelativity.js'
import VerticalLineElement from '@/domain/scene/generic/VerticalLineElement.js'

const INDICATOR_LINE_COLOR = 'rgb(70, 70, 70)'
const INDICATOR_LINE_WEIGHT = 1

export default class IndicatorLine extends VerticalLineElement {
  constructor (name, lengthRel, initXRel, initYRel, drawUp = false) {
    super(
      name,
      lengthRel,
      initXRel,
      initYRel,
      INDICATOR_LINE_COLOR,
      INDICATOR_LINE_WEIGHT,
      drawUp
    )
  }

  setOnScene (sceneWidth, sceneHeight, speedC = null) {
    super.setOnScene(sceneWidth, sceneHeight)

    if (speedC !== null) {
      this.x = parseInt(lengthContraction(this.x, speedC))
    }
  }
}
